import { render, staticRenderFns } from "./Atestos.vue?vue&type=template&id=14a7ed65"
import script from "./Atestos.vue?vue&type=script&lang=js"
export * from "./Atestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports